import SuccessDomainRegister from "components/SuccessDomain/SuccessDomainRegister";
import { useQuery } from "helpers/utils";
import {
  search,
  searchDomainName,
} from "features/domain/domainsSlice";
import { useEffect, useRef, useState, forwardRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import {
  searchDomains,
} from "features/domain/domainsSlice";
import { notifyWarning, notifyError } from "components/ToastMessage";
import { Card, Form, Spinner } from 'react-bootstrap';

const validateDomain = (domainInput, extensionTransfer, setDisableRegister) => {
  const kamus = [
    "togel",
    "judi",
    "sex",
    "porn",
    "bugil",
    "bokep",
    "xxx",
    "kontol",
    "casino",
    "kasino",
  ];

  const whitelist = [
    "camillajava",
    "javaleap",
    "unigoldtechnology",
    "livelifebetter",
    "sirajudinhasbi",
    "javapustaka",
    "lajudigital",
    "westjava-shizuoka",
    "betariko",
    "tipjavatransport",
  ];

  const validateSingleDomain = (domainName) => {
    const badWord = kamus.some((str) => domainName.includes(str));
    const whiteWord = whitelist.some((str) => domainName.includes(str));

    if (badWord && !whiteWord) {
      notifyWarning("Domain Anda mengandung kata terlarang!");
      setDisableRegister(false);
      return false;
    }

    if (domainName.length < 2) {
      notifyWarning("Nama domain minimal 2 karakter!");
      setDisableRegister(false);
      return false;
    }

    if (!domainName) {
      notifyWarning("Domain Anda kosong!");
      setDisableRegister(false);
      return false;
    }

    if (!extensionTransfer) {
      notifyWarning("Ekstensi Anda kosong!");
      setDisableRegister(false);
      return false;
    }

    if (/[<> !@#$%^&*()_+=;:?/\\|}{\][~`]/.test(domainName)) {
      notifyWarning("Domain Anda tidak valid!");
      setDisableRegister(false);
      return false;
    }

    return true;
  };

  if (Array.isArray(domainInput)) {
    return domainInput.every((domain) => validateSingleDomain(domain));
  } else {
    return validateSingleDomain(domainInput);
  }
};

const RegisterDomain = forwardRef((props, ref) => {
  const { registrationType, setRegistrationType, domainMethod, setDomainMethod, onToggleDomainSections } = props;
  const { status } = useSelector((state) => state.domain);
  const { noDomain } = useSelector((state) => state.hosting);
  const query = useQuery();
  const dispatch = useDispatch();
  const tldRef = useRef();
  const domainRegister = query.domainregister;

  const [extension, setExtension] = useState("");
  const [price, setPrice] = useState([]);
  const [domain, setDomain] = useState("");
  const [disableRegister, setDisableRegister] = useState(false);
  const [isAutoFocus, setIsAutoFocus] = useState(false);
  const [isAutoFocusMultiple, setIsAutoFocusMultiple] = useState(false);
  const [multipleDomains, setMultipleDomains] = useState("");
  const [promoDomains, setPromoDomains] = useState([]);

  let notifyTimeout;

  // Function to handle domain sections toggle
  const handleToggleDomainSections = (shouldShow) => {
    onToggleDomainSections(shouldShow);
    
    // If showing sections, focus on the domain input after a short delay
    if (shouldShow) {
      setTimeout(() => {
        const domainInput = document.getElementById("searchDomain");
        if (domainInput) {
          domainInput.focus();
          domainInput.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }, 100);
    }
  };

  useEffect(() => {
    if (domainRegister) {
      const domainArr = domainRegister
        .split(",")
        .map((domain) => domain.trim());
      const extDomainArr = domainArr.map((domain) => domain.split(".")[1]);

      const isValid = validateDomain(domainArr, extDomainArr, setDisableRegister);
      if (!isValid) return;

      if (domainArr.length > 1) {
        setRegistrationType("multiple");
      } else {
        setRegistrationType("single");
      }

      domainArr.forEach(domain => checkDomainPromo(domain));

      dispatch(searchDomains(domainArr));
    }
  }, [domainRegister, dispatch, setRegistrationType]);

  const searchDomain = (e) => {
    e.preventDefault();

    const isValid = validateDomain(domain, extension, setDisableRegister);
    if (!isValid) return;

    const domainWithExtension = domain + extension;

    // Check for .id extension and billing cycle annually
    if (extension === ".id") {
      checkDomainPromo(domainWithExtension);
    }

    dispatch(search({ domain, extension, price }));
    dispatch(searchDomainName(domainWithExtension));

    setDisableRegister(true);
  };

  const options = (props.extOption || []).map(function (option) {
    return { value: option[1], label: option[1], price: option[4] };
  });

  const handleExtension = (e) => {
    if (!e) {
      setExtension("");
      return;
    }
    setExtension(e.value);
    setPrice(e.price);
  };

  const setDomainHandler = (e) => {
    const { value } = e.target;
    // Remove special characters including period and comma using regex
    const domainWithoutSpecialChars = value.replace(/[.,]/g, "");
    setDomain(domainWithoutSpecialChars);

    // Check if dot button is pressed
    if (value.endsWith(".")) {
      tldRef.current.focus();
    }
  };

  const setDomainHandlerMultiple = (e) => {
    const { value } = e.target;
    const domainWithCommas = value.replace(/[<> !@#$%^&*()_+=;:?/\\|}{\][~`]/g, "");
    setMultipleDomains(domainWithCommas);

    // Split domains and trim spaces
    const domains = domainWithCommas.split(',').map(d => d.trim());

    // Check for trailing comma without a domain
    if (domains[domains.length - 1] === "") {
      notifyWarning("Domain tidak boleh diakhiri dengan koma tanpa domain berikutnya!");
      return;
    }

    const validDomains = domains.filter(d => d.length > 0);

    for (let domain of validDomains) {
      const parts = domain.split('.');
      const extension = `.${parts[parts.length - 1]}`;

      const selectedOption = options.find(option => option.value === extension);
      if (selectedOption) {
        setPrice(selectedOption.price);
      }
    }
  };

  useEffect(() => {
    if (status !== "loading") {
      setDisableRegister(false);
    }
  }, [status]);

  useEffect(() => {
    if (query.extension) {
      fetch(
        `${process.env.REACT_APP_BASE_API}order/apis/get-price-domain.php?tipedomain=domainregister&extension=` +
          query.extension
      )
        .then((data) => data.json())
        .then((val) => {
          let price = parseFloat(val.data[0].msetupfee);
          setExtension(query.extension);
          setPrice(String(price));
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [query.extension]);

  useEffect(() => {
    if (noDomain) {
      setTimeout(() => {
        if (registrationType === "single") {
          setIsAutoFocus(true);
          ref.current.focus();
        } else {
          setIsAutoFocusMultiple(true);
          ref.current.focus();
        }
      }, 500);
    }
  }, [noDomain, ref, registrationType]);

  const checkDomainPromo = async (domain) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_API}order/apis/checkDomainPromo.php?domain=${encodeURIComponent(domain)}`);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      if (data.code === 200 && domain.endsWith('.id')) {
        // console.log("Domain ini memiliki promo");
        setPromoDomains((prev) => [...prev, domain]);
      } else {
        // console.log("Domain ini tidak memiliki Promo");
      }
    } catch (error) {
      console.error("Error checking promo domain:", error);
    }
  };

  const searchMultipleDomains = (e) => {
    e.preventDefault();
    const domains = multipleDomains.split(',').map(d => d.trim());

    // Check for trailing comma without a domain
    if (domains[domains.length - 1] === "") {
      if (!notifyTimeout) {
        notifyWarning("Domain tidak boleh diakhiri dengan koma tanpa domain berikutnya!");
        notifyTimeout = setTimeout(() => {
          notifyTimeout = null;
        }, 10000); // 10 seconds
      }
      return;
    }

    const validDomains = domains.filter(d => d.length > 0);

    if (validDomains.length === 0) {
      notifyWarning("Domain Anda kosong!");
      return;
    }

    const validExtensions = options.map(option => option.value);
    const invalidDomains = validDomains.filter(domain => {
      const parts = domain.split('.');
      const extension = `.${parts[parts.length - 1]}`;
      return !validExtensions.includes(extension);
    });

    if (invalidDomains.length > 0) {
      notifyError(`Maaf, Domain ini memiliki ekstensi tidak valid: ${invalidDomains.join(', ')}`);
      return;
    }

    // Validate each domain
    const allValid = validDomains.every(domain => validateDomain(domain, domain.split('.').pop(), setDisableRegister));
    if (!allValid) return;

    // Check for .id extension and billing cycle annually
    for (const domain of validDomains) {
      const parts = domain.split('.');
      const extension = `.${parts[parts.length - 1]}`;
      if (extension === ".id") {
        checkDomainPromo(domain);
      }
    }

    dispatch(searchDomains(validDomains));
    setDisableRegister(true);
  };

  const handleRegistrationTypeChange = (e) => {
    const value = e.target.value;
    setRegistrationType(value);
    setDomainMethod("register");
  };


    return (
    <Card className="rounded-4 border-0 shadow-sm mb-4">
      <Card.Body>
        <div className="row">
          <div className="col-12">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="fw-bold text-qw-primary mb-0">
                Pilih Jenis Domain
              </h5>
            </div>
            
            {/* Daftar Domain Baru */}
            <div className="form-check py-3 px-4 mb-3" style={{ 
              border: '2px solid #e0e6ed',
              borderRadius: '8px',
              backgroundColor: registrationType === "single" && domainMethod === "register" ? '#f8f9fa' : 'transparent'
            }}>
              <div className="d-flex align-items-start ps-2">
                <input
                  type="radio"
                  className="form-check-input me-3"
                  name="domainMethod"
                  id="daftarDomain1"
                  value="single"
                  checked={registrationType === "single" && domainMethod === "register"}
                  onChange={handleRegistrationTypeChange}
                  style={{ marginTop: '2px' }}
                />
                <div className="flex-grow-1">
                  <label
                    htmlFor="daftarDomain1"
                    className="form-check-label fw-bold d-block"
                  >
                    Daftar Domain
                  </label>
                  <p className="mb-0 mt-2 text-muted">
                    Miliki ekstensi Domain terbaik untuk identitas website & bisnis di internet
                  </p>

                    {registrationType === "single" && domainMethod === "register" && !query.domainregister && (
                      <form onSubmit={searchDomain} className="mt-3">
                        <div className="row g-3">
                          <div className="col-12 col-md-5">
                            <Form.Control
                              id="searchDomain"
                              type="text"
                              ref={ref}
                              placeholder="Nama Domain Anda"
                              onChange={(e) => setDomainHandler(e)}
                              value={domain}
                              autoFocus={isAutoFocus}
                              style={{ 
                                border: '2px solid #e0e6ed',
                                borderRadius: '8px',
                                padding: '10px 16px'
                              }}
                            />
                          </div>
                          <div className="col-12 col-md-4">
                            <Select
                              className="basic-single"
                              classNamePrefix="select"
                              onChange={handleExtension}
                              isSearchable={true}
                              name="extensions"
                              options={options}
                              ref={tldRef}
                              placeholder="Pilih ekstensi..."
                              defaultValue={query.extension ? { value: query.extension, label: query.extension } : ""}
                              styles={{
                                control: (provided) => ({
                                  ...provided,
                                  border: '2px solid #e0e6ed',
                                  borderRadius: '8px',
                                  padding: '4px 8px'
                                })
                              }}
                            />
                          </div>
                          <div className="col-12 col-md-3">
                            <button
                              className="btn btn-cta w-100 rounded-5"
                              type="submit"
                              disabled={disableRegister}
                              style={{ 
                                borderRadius: '8px',
                                padding: '10px 16px'
                              }}
                            >
                              {disableRegister ? (
                                <>
                                  <Spinner animation="border" size="sm" className="me-2" />
                                  Memproses...
                                </>
                              ) : (
                                'Cek Domain'
                              )}
                            </button>
                          </div>
                        </div>
                      </form>
                    )}
                  </div>
                </div>
            </div>

            {/* Pesan Banyak Domain */}
            <div className="form-check py-3 px-4 mb-3" style={{ 
              border: '2px solid #e0e6ed',
              borderRadius: '8px',
              backgroundColor: registrationType === "multiple" && domainMethod === "register" ? '#f8f9fa' : 'transparent'
            }}>
              <div className="d-flex align-items-start ps-2">
                <input
                  type="radio"
                  className="form-check-input me-3"
                  name="domainMethod"
                  id="daftarDomain2"
                  value="multiple"
                  checked={registrationType === "multiple" && domainMethod === "register"}
                  onChange={handleRegistrationTypeChange}
                  style={{ marginTop: '2px' }}
                />
                <div className="flex-grow-1">
                  <label
                    htmlFor="daftarDomain2"
                    className="form-check-label fw-bold d-block"
                  >
                    Pesan Banyak Domain Baru
                  </label>
                  <p className="mb-0 mt-2 text-muted">
                    Pesan banyak Domain terbaik dengan ekstensi berbeda
                  </p>

                    {registrationType === "multiple" && domainMethod === "register" && (
                      <form onSubmit={searchMultipleDomains} className="mt-3">
                        <div className="row g-3">
                          <div className="col-12 col-md-9">
                            <Form.Control
                              id="searchMultipleDomain"
                              type="text"
                              ref={ref}
                              placeholder="gfn1.id, gfn2.com, ... (Pisahkan dengan koma)"
                              onChange={(e) => setDomainHandlerMultiple(e)}
                              value={multipleDomains}
                              autoFocus={isAutoFocusMultiple}
                              style={{ 
                                border: '2px solid #e0e6ed',
                                borderRadius: '8px',
                                padding: '10px 16px'
                              }}
                            />
                          </div>
                          <div className="col-12 col-md-3">
                            <button
                              className="btn btn-cta w-100 rounded-5"
                              type="submit"
                              disabled={disableRegister}
                              style={{ 
                                borderRadius: '8px',
                                padding: '10px 16px'
                              }}
                            >
                              {disableRegister ? (
                                <>
                                  <Spinner animation="border" size="sm" className="me-2" />
                                  Memproses...
                                </>
                              ) : (
                                'Cek Domain'
                              )}
                            </button>
                          </div>
                        </div>
                      </form>
                    )}
                  </div>
                </div>
            </div>

            {/* Success Message Component */}
            {(domainRegister || domainMethod === "register") && (
              <SuccessDomainRegister 
                extensions={props.extOption} 
                mode={registrationType} 
                promoDomains={promoDomains}
                onToggleDomainSections={handleToggleDomainSections}
              />
            )}
          </div>
        </div>
      </Card.Body>
    </Card>
  );
});

export default RegisterDomain;
